import { h } from 'preact'
import DragHandle from '../control/DragHandle'
import Switcher from '../control/Switcher'
import {Tab} from './TabsConfigurator'

interface Props {
  title: string,
  phrase: string,
  enabled: boolean,
  placeholder: string,
  onChange: (value: Tab[keyof Tab], field: keyof Tab) => void
}

function isInputEl(el: EventTarget| null): el is HTMLInputElement {
  return !!el && 'value' in el
}

const Category = (props: Props) =>
  <div class='tab'>
    <div><DragHandle /> <span>{props.title}</span></div>
      <input type='text' value={props.phrase} onKeyUp={e => {
          if (isInputEl(e.target)) props.onChange(e.target?.value, 'phrase')}
        } placeholder={props.placeholder} />
    <Switcher on={props.enabled} onChange={() => props.onChange(!props.enabled, 'enabled')} />
  </div>

export default Category
